<div
  data-section="language-banner"
  role="button"
  tabindex="0"
  class="tw-relative tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-3 tw-border tw-border-orange-100 tw-bg-orange-90 tw-px-3 tw-py-4 tw-shadow-z4"
  (click)="onBannerTap()"
  (keydown.enter)="onBannerTap()"
  (keydown.space)="onBannerTap()">
  <cs-icon
    data-element="globe-icon"
    class="tw-h-8 tw-w-8 tw-shrink-0 tw-text-teal-50"
    [iconName]="'language_globe_teal'"></cs-icon>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-items-start">
    <span data-element="header" class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800" style="font-weight: 700 !important" i18n="@@changeAppLanguage">Change App language</span>
    <span data-element="subtitle" class="tw-font-lexend tw-text-100 tw-text-gray-500">हिन्दी | मराठी | বাংলা | తెలుగు | ಕನ್ನಡ | English</span>
  </div>
  <div
    data-element="language-pill"
    class="tw-flex tw-h-6 tw-shrink-0 tw-items-center tw-gap-1 tw-rounded-3 tw-border tw-border-teal-600 tw-px-2">
    <span class="tw-font-lexend tw-font-bold tw-text-100 tw-text-teal-600" style="font-weight: 700 !important">{{ content().currentLanguageLabel }}</span>
    <cs-icon class="tw-h-3 tw-w-3 tw-shrink-0 tw-text-teal-600" [iconName]="'chevron_down_teal'"></cs-icon>
  </div>
</div>
